// extracted by css-extract-rspack-plugin
export default {"banner-status-icon":"IconStatus-module__banner-status-icon--oXIem","bannerStatusIcon":"IconStatus-module__banner-status-icon--oXIem"};